const URL = process.env.NODE_ENV === 'production' ? 'https://warehouseapi.qianchanchan.com/' : 'http://localhost:21021/';
export default URL;